import {createApp} from 'vue'
import options from './FrivilligGroupHero.options'

const el = '.kb-component--frivillig-group-hero'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FrivilligGroupHeroDOM)=>{
            options.template = FrivilligGroupHeroDOM.innerHtml
            const props = {
                gruppeKode: FrivilligGroupHeroDOM.dataset.gruppeKode,
                isLoggedIn: FrivilligGroupHeroDOM.dataset.isLoggedIn === 'true',
                loginUrl: FrivilligGroupHeroDOM.dataset.loginUrl,
                closedGroup: FrivilligGroupHeroDOM.dataset.gruppeIsClosed === 'true'
            }
            const component = createApp(options, props).use(Store)
            component.mount(FrivilligGroupHeroDOM)
        })
    }
}

